import { Typography } from '@jouzen/ecom-components/v3/Typography';
import { useReducedMotion } from 'framer-motion';
import type { MessageKey } from 'types/LocaleMessageKey';
import type { SVGIconComponent } from 'types/svgr';

import type { MotionProps } from '@/app/components/Motion';
import Motion from '@/app/components/Motion';
import RichText from '@/app/components/RichText';

export interface AccuracyCardProps {
  readonly heading: MessageKey;
  readonly icon: SVGIconComponent;
  readonly note?: MessageKey;
  readonly percentage: number;
}

const TabletAccuracyCard = ({
  heading,
  icon: Icon,
  note,
  percentage,
}: AccuracyCardProps) => {
  const shouldReduceMotion = useReducedMotion();
  const motionProps: MotionProps = {
    initial: {
      translateY: shouldReduceMotion ? 0 : 20,
      opacity: 0,
    },
    transition: {
      duration: 0.5,
      delay: 0.5,
    },
    viewport: {
      once: true,
    },
    whileInView: {
      translateY: 0,
      opacity: 1,
    },
  };
  return (
    <div
      className="relative flex flex-col gap-y-3 rounded-lg bg-sandstone-400 p-5"
      data-cy="tablet-accuracy-card"
    >
      <Motion {...motionProps}>
        <div className="relative flex justify-between gap-x-6">
          <Typography
            Element="div"
            font="serif"
            variant="h2"
            height="tight"
            className="font-extralight"
          >
            {percentage.toLocaleString(undefined, { style: 'percent' })}
          </Typography>
          <div className="size-6 pt-1">
            <Icon width={24} height={24} />
          </div>
        </div>
        <div className="relative text-sandstone-500">
          <Typography Element="div" color="inherit" variant="body-small">
            <RichText messageKey={heading} />
          </Typography>
          {note && (
            <Typography Element="div" color="inherit" variant="eyebrow-small">
              <RichText messageKey={note} />
            </Typography>
          )}
        </div>
      </Motion>
    </div>
  );
};

export default TabletAccuracyCard;
